// extracted by mini-css-extract-plugin
module.exports = {"card":"EventCard_card__EmWV_","btn":"EventCard_btn__3ZbV9","extra":"EventCard_extra__1AYDg"};